import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSupport = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9085 16.5088C21.8684 14.6799 22.2174 12.5026 21.8684 10.2382C21.1703 6.14495 17.7671 2.7484 13.6659 2.13877C6.85958 1.00658 1.01314 6.84168 2.14752 13.6348C2.84561 17.7281 6.07424 21.1246 10.2627 21.8213C12.5315 22.2568 14.6258 21.8213 16.4582 20.9504L16.5455 20.9504L20.734 21.6472C21.2575 21.7342 21.6938 21.2988 21.6066 20.7762L20.9085 16.5959V16.5088ZM16.4582 19.1215C16.2837 19.0344 16.1092 19.1215 16.0219 19.2086C14.8003 19.9053 13.4914 20.2537 12.0079 20.2537C7.47041 20.2537 3.71821 16.5088 3.71821 11.9801C3.71821 7.45132 7.47041 3.7064 12.0079 3.7064C16.5455 3.7064 20.2977 7.45132 20.2977 11.9801C20.2977 13.4606 19.9486 14.8541 19.2506 16.0733C19.1633 16.1604 19.1633 16.3346 19.1633 16.5088L19.6869 19.7311L16.4582 19.1215Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.39297 13.7359C10.3532 13.7359 11.1317 12.9575 11.1317 11.9972C11.1317 11.037 10.3532 10.2585 9.39297 10.2585C8.43273 10.2585 7.6543 11.037 7.6543 11.9972C7.6543 12.9575 8.43273 13.7359 9.39297 13.7359Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6098 13.7359C15.57 13.7359 16.3484 12.9575 16.3484 11.9972C16.3484 11.037 15.57 10.2585 14.6098 10.2585C13.6495 10.2585 12.8711 11.037 12.8711 11.9972C12.8711 12.9575 13.6495 13.7359 14.6098 13.7359Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgSupport);
export default ForwardRef;
